import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import backgroundSVG from '../assets/images/background.svg';
// Removing unused logo import
import './HeroSection.css';

const HeroSection = () => (
  <section className="hero-section">
    <div className="hero-bg-svg"></div>
    <div className="hero-content">
      {/* <img src={logo} alt="Logo" className="hero-logo" /> */}
      <h1 className="hero-title">From Fridge Dilemma to Delicious Dinner</h1>
      <h2 className="hero-subtitle lavender-center">
        <Typewriter
          words={[
            'Tackling food waste and mealtime stress with Generative AI.',
            'A Capstone Project from the Google Gen AI Intensive Course.'
          ]}
          loop={0}
          cursor
          cursorStyle="_"
          typeSpeed={40}
          deleteSpeed={30}
          delaySpeed={2000}
        />
      </h2>
      {/* <div className="hero-capstone feminine-pink">
        A Capstone Project from the Google Gen AI Intensive Course.
      </div> */}
      {/* <div className="hero-by">By Nariman Jafarieshlaghi & Neda Saberitabar</div> */}
    </div>
  </section>
);

export default HeroSection;
